<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-row align="center" justify="center">
          <h1>お疲れ様でした🎉</h1>
          <v-alert color="secondary" width="90%" class="mt-6" outlined>
            {{ doneCountTitle }}
          </v-alert>
          <v-alert color="primary" width="90%" outlined>
            {{ correctCountTitle }}
          </v-alert>
          <v-alert color="accent" width="90%" outlined>
            {{ wrongCountTitle }}
          </v-alert>
        </v-row>
        <v-footer fixed class="button-botton-area-footer">
          <v-col cols="12" class="button-botton-area">
            <v-row align="center" justify="center">
              <v-btn
                bottom
                color="primary"
                height="60px"
                width="100%"
                dark
                class="disable-dbl-tap-zoom"
                @click="executeDone"
              >
                トップへ戻る
              </v-btn>
            </v-row>
          </v-col>
        </v-footer>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { db, fb } from "../plugins/firebase.js";

export default {
  name: "WordNoteTestDone",
  components: {},
  data: () => ({
    editingWords: [],
  }),
  async mounted() {
    if (this.$route.params.editingWords) {
      this.updateWordsWithTestResult(this.$route.params.editingWords);
    }
  },
  methods: {
    updateWordsWithTestResult(results) {
      var batch = db.batch();
      const noteId = this.$store.getters.currentNoteId;

      results.forEach((result) => {
        const wordRef = db
          .collection(`users/${this.uid}/word-notes`)
          .doc(noteId)
          .collection("words")
          .doc(result.id);
        switch (result.type) {
          case "done":
            batch.update(wordRef, {
              done: true,
              updatedAt: fb.firestore.FieldValue.serverTimestamp(),
            });
            break;
          case "correct":
            batch.update(wordRef, {
              correctCount: fb.firestore.FieldValue.increment(1),
              updatedAt: fb.firestore.FieldValue.serverTimestamp(),
            });
            break;
          case "wrong":
            batch.update(wordRef, {
              wrongCount: fb.firestore.FieldValue.increment(1),
              updatedAt: fb.firestore.FieldValue.serverTimestamp(),
            });
            break;
        }
      });
      batch
        .commit()
        .then(function () {})
        .catch(function (error) {
          console.log(error);
        });
    },
    executeDone() {
      this.$router.push("/");
    },
  },
  computed: {
    doneCountTitle() {
      var count = 0;
      if (this.$route.params.editingWords) {
        this.$route.params.editingWords.forEach((element) => {
          if (element.type == "done") {
            count += 1;
          }
        });
      }

      return `完了数: ${count}語`;
    },
    uid() {
      return this.$store.getters.uid;
    },
    correctCountTitle() {
      var count = 0;
      if (this.$route.params.editingWords) {
        this.$route.params.editingWords.forEach((element) => {
          if (element.type == "correct") {
            count += 1;
          }
        });
      }

      return `正解数: ${count}語`;
    },
    wrongCountTitle() {
      var count = 0;
      if (this.$route.params.editingWords) {
        this.$route.params.editingWords.forEach((element) => {
          if (element.type == "wrong") {
            count += 1;
          }
        });
      }

      return `不正回数: ${count}語`;
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 600px;
}
.button-botton-area-footer {
  background-color: white !important;
}
.button-botton-area {
  max-width: 600px;
  margin: auto;
}
.disable-dbl-tap-zoom {
  touch-action: manipulation;
}
</style>
